import * as THREE from 'three';
import type { Entity, EntityCtx } from './Entity';
import { useStore } from '../state/store';

const _partWp = new THREE.Vector3();
/** Pick the world point a ground unit should aim at for `target`: the nearest surviving
 *  hit-part for multi-part bosses (their centroid is invincible), else the centroid. */
export function aimPointFor(target: Entity, from: THREE.Vector3, out: THREE.Vector3): THREE.Vector3 {
  if (target.hitParts && target.hitParts.length > 0) {
    let bestD = Infinity;
    let found = false;
    for (const part of target.hitParts) {
      part.object.getWorldPosition(_partWp);
      const d = _partWp.distanceToSquared(from);
      if (d < bestD) { bestD = d; out.copy(_partWp); found = true; }
    }
    if (found) return out;
  }
  return out.copy(target.position);
}

/** Called when the player's currently-controlled unit is destroyed and there's no other
 *  unit to hand control to — the whole force is wiped, so the run ends. Used by ground
 *  units (planes run their own crash cinematic instead). */
export function endRunOnLastUnit(
  unit: Entity & { camera?: THREE.PerspectiveCamera | null },
  ctx: EntityCtx,
) {
  const store = useStore.getState();
  if (store.phase !== 'playing') return; // a village-loss game-over may already have fired
  store.setLossReason('shotdown');
  store.beginDeath(ctx.now);
  store.markDeathImpact(ctx.now); // ground units have no fall — show the retry promptly
  store.setHp(0);
  // Detach the camera to the scene so the game-over view survives this unit's disposal.
  if (unit.camera) ctx.scene.attach(unit.camera);
  store.setPhase('gameover');
}
